import request from '@/utils/request'

const api = '/pro/tianyan/'

// 获取当前接口价格根据编码
export function getByCodes(data) {
    return request({
      url: '/system/interface/getByCodes',
      method: 'get',
      params:data
    })
}
// 获取当前接口价格根据编码
export function businessInformation(data) {
    return request({
      url: api+'businessInformation',
      method: 'get',
      params:data
    })
}

// 获取当前接口价格根据编码
export function businessInformationNoError(data) {
  return request({
    url: api+`/businessInformation`,
    method: 'get',
    headers: {
      isErrorMsg: false
    },
    params:data
  })
}
